import {billingActionTypes} from "../actions/actionTypes";

const initialState = {
    plaidEnvironment: null,
    plaidLinkToken: null,
    stripePublicKey: null,
    paymentMethods: [],
    microDepositsBankAccounts: [],
    autoPay: null,
    currentInvoices: null,
    previewInvoice: null,
    historicalInvoices: [],
    accountBalance: null,
    currentBilling: null,
    pastDue: null,
    today: null,
    lastPaymentFailed: null,
    lastPaymentDate: null,
    lastPaymentAmount: null,
    isNotAvailableToPay: null,
    accountSummaryCardLoading: false,
};

export const billingReducer = (state = initialState, action) => {
    switch (action.type) {
        case billingActionTypes.SET_BILLING_DATA:
            const billingData = action.payload;
            return {
                ...state,
                plaidEnvironment: billingData.plaidEnvironment,
                plaidLinkToken: billingData.plaidLinkToken,
                stripePublicKey: billingData.stripePublicKey,
                paymentMethods: billingData.paymentMethods,
                microDepositsBankAccounts: billingData.microDepositsBankAccounts,
                autoPay: billingData.autoPay,
                currentInvoices: billingData.currentInvoices,
                previewInvoice: billingData.previewInvoice,
                historicalInvoices: billingData.historicalInvoices,
                accountBalance: billingData.accountBalance,
                currentBilling: billingData.currentBilling,
                pastDue: billingData.pastDue,
                today: billingData.today,
                lastPaymentDate: billingData.lastPaymentDate,
                lastPaymentAmount: billingData.lastPaymentAmount,
                lastPaymentFailed: billingData.lastPaymentFailed,
                isNotAvailableToPay: billingData.isNotAvailableToPay,
                billingAccountId: billingData.billingAccountId,
            }
        case billingActionTypes.SET_PAYMENT_METHODS:
            return {
                ...state,
                paymentMethods: action.payload,
            }
        case billingActionTypes.SET_MICRO_DEPOSITS_BANK_ACCOUNT:
            return {
                ...state,
                microDepositsBankAccounts: [...state.microDepositsBankAccounts, action.payload],
            }
        case billingActionTypes.DELETE_MICRO_DEPOSITS_BANK_ACCOUNT:
            return {
                ...state,
                microDepositsBankAccounts: state.microDepositsBankAccounts.filter(el => el.accountId !== action.payload),
            }
        case billingActionTypes.SET_MICRO_DEPOSITS_BANK_ACCOUNT_FAILED:
            const updatedList = state.microDepositsBankAccounts.map((bank) => {
                if(bank.accountId === action.payload) {
                    bank.status = "verification_failed"
                }
                return bank;
            })

            return {
                ...state,
                microDepositsBankAccounts: updatedList
            }
        case billingActionTypes.SET_ACCOUNT_SUMMARY_CARD_LOADING:
            return {
                ...state,
                accountSummaryCardLoading: action.payload,
            }
        case billingActionTypes.SET_AUTO_PAY:
            return {
                ...state,
                autoPay: action.payload,
            }
        case billingActionTypes.PATCH_MICRO_DEPOSIT_BANK_ACCOUNT:
            const newMicroDepositsBankAccounts = [ ...state.microDepositsBankAccounts ]
            const { accountId } = action.payload;

            for (let i = 0; i < newMicroDepositsBankAccounts.length; i++) {
                if (newMicroDepositsBankAccounts[i].accountId === accountId) {
                    newMicroDepositsBankAccounts[i].status = "verification_failed"
                    break;
                }
            }

            return {
                ...state,
                microDepositsBankAccounts: newMicroDepositsBankAccounts
            }
        case billingActionTypes.SET_IS_NOT_AVAILABLE_TO_PAY:
            return {
                ...state,
                isNotAvailableToPay: action.payload,
            }
        default:
            return state
    }
}